module.exports = __webpack_public_path__ + "static/media/gb.2e9c71c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gb.svg
// module id = 122
// module chunks = 0